
// vue
import { defineComponent, reactive } from 'vue';

export default defineComponent({
  name: 'Card',
  props: {
    inner: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  setup(props) {
    const className = reactive<string[]>([]);
    if (!props.inner) {
      className.push('p0');
    }
    return { className };
  },
});
